export const APP_ID = 'saywhatt-app';
export const WRAPPER_ELEMENT_ID = 'saywhatt-outer-div';

export const ANNOUNCEMENT_BAR_ELEMENTS = [
  '.local-announcement-bar', // Local
  '#section-id-announcement-bar', // Nununu old
  '.announcement-banner', // Ahava
  '.announcement-bar', // Nununu new
];
